/**
 * WebSocket token refresh utility.
 *
 * Delegates to @platform/auth-sdk token storage and refresh service.
 * Used by WebSocket connections that need to re-authenticate after a 4001/4002 close.
 */
import { getAccessToken, getRefreshToken, createTokenRefreshService, storeTokens } from '@platform/auth-sdk';

const refreshService = createTokenRefreshService({
  identityCenterUrl: import.meta.env.VITE_IDENTITY_CENTER_URL || 'https://id.digihrms.com',
  onTokensRefreshed: (accessToken, refreshToken) => {
    storeTokens({ accessToken, refreshToken });
  },
  onRefreshFailure: () => {
    // Auth failure — the SDK AuthProvider will handle redirect to login
  },
});

export async function refreshAccessToken() {
  // First try to get a valid access token from storage
  const currentToken = getAccessToken();
  if (currentToken) {
    return currentToken;
  }

  // No valid token — attempt refresh
  const refreshToken = getRefreshToken();
  if (!refreshToken) return null;

  try {
    const newToken = await refreshService.refreshTokens();
    return newToken;
  } catch {
    return null;
  }
}
